import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.folhar.cadastra(payload).then(res => {
        dispatch('ActionSetFolharId',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.folhar.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.folhar.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.folhar.delete(payload).then(res => {
      
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.folhar.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.folhar.update(payload).then(res => {
        dispatch('ActionSetFolharId',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionServico = ({dispatch},payload)=>{
    return serves.folhar.servico(payload).then(res => {
        dispatch('ActionSetSevico',res)
    }).catch(err => {
        dispatch('ActionSetSevico',err)
    })
}
export const ActionServicoGeral = ({dispatch},payload)=>{
    return serves.folhar.servicogeral(payload).then(res => {
        dispatch('ActionSetSevicoGeral',res)
    }).catch(err => {
        dispatch('ActionSetSevicoGeral',err)
    })
}
export const ActionBaseCalculoCadastro = ({dispatch},payload)=>{
    return serves.folhar.basecalculo(payload).then(res => {
        dispatch('ActionSetBaseCalculo',res)
    }).catch(err => {
        dispatch('ActionSetBaseCalculo',err)
    })
}
export const ActionValorCalculo = ({dispatch},payload)=>{
    return serves.folhar.valorcalculo(payload).then(res => {
        dispatch('ActionSetValorCalculo',res)
    }).catch(err => {
        dispatch('ActionSetValorCalculo',err)
    })
}
export const ActionValorCalculoGeral = ({dispatch},payload)=>{
    return serves.folhar.valorcalculogeral(payload).then(res => {
        dispatch('ActionSetValorCalculoGeral',res)
    }).catch(err => {
        dispatch('ActionSetValorCalculoGeral',err)
    })
}
export const ActionValorCalculoCadastro = ({dispatch},payload)=>{
    return serves.folhar.valorcalculocadastro(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionComissionado = ({dispatch},payload)=>{
    return serves.folhar.comissionador(payload).then(res => {
        dispatch('ActionSetComissionado',res)
    }).catch(err => {
        dispatch('ActionSetComissionado',err)
    })
}
export const ActionDias = ({dispatch},payload)=>{
    return serves.folhar.dias(payload).then(res => {
        dispatch('ActionSetDias',res)
    }).catch(err => {
        dispatch('ActionSetDias',err)
    })
}
export const ActionDiasCadastro = ({dispatch},payload)=>{
    return serves.folhar.diascadastro(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionQuinzena = ({dispatch},payload)=>{
    return serves.folhar.quinzena(payload).then(res => {
        dispatch('ActionSetQuizena',res)
    }).catch(err => {
        dispatch('ActionSetQuizena',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    return serves.folhar.evento(payload).then(res => {
        dispatch('ActionSetEvento',res)
    }).catch(err => {
        dispatch('ActionSetEvento',err)
    })
}
export const ActionBancos = ({dispatch},payload)=>{
    return serves.folhar.bancos(payload).then(res => {
        dispatch('ActionSetBancos',res)
    }).catch(err => {
        dispatch('ActionSetBancos',err)
    })
}
export const ActionRublicas = ({dispatch},payload)=>{
    return serves.folhar.rublicas(payload).then(res => {
        dispatch('ActionSetRublicas',res)
    }).catch(err => {
        dispatch('ActionSetRublicas',err)
    })
}
export const ActionEventoFechamento = ({dispatch},payload)=>{
    return serves.folhar.eventofechamento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoAbertura = ({dispatch},payload)=>{
    return serves.folhar.eventoabertura(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionTomadores = ({dispatch},payload)=>{
    return serves.folhar.tomadores(payload).then(res => {
        dispatch('ActionSetTomadores',res)
    }).catch(err => {
        dispatch('ActionSetTomadores',err)
    })
}
export const ActionUpdateEvento = ({dispatch},payload)=>{
    return serves.folhar.eventoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionAutomatico = ({dispatch},payload)=>{
    return serves.folhar.automatico(payload).then(res => {
        dispatch('ActionSetAutomatico',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDiasUteis = ({dispatch},payload)=>{
    return serves.folhar.dias(payload).then(res => {
        dispatch('ActionSetDiasUteis',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDiasNaoUteis = ({dispatch},payload)=>{
    return serves.folhar.dias(payload).then(res => {
        dispatch('ActionSetDiasNaoUteis',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionFeriado = ({dispatch},payload)=>{
    return serves.folhar.dias(payload).then(res => {
        dispatch('ActionSetFeriado',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionFolhas = ({dispatch},payload)=>{
    return serves.folhar.lista(payload).then(res => {
        dispatch('ActionSetFolhas',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionConfigTrabalhador = ({dispatch},payload)=>{
    return serves.folhar.configtrabalhador(payload).then(res => {
        dispatch('ActionSetConfigTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionTrabalhadores = ({dispatch},payload)=>{
    return serves.folhar.trabalhadores(payload).then(res => {
        dispatch('ActionSetTrabalhadores',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionTrabalhadoresGeral = ({dispatch},payload)=>{
    return serves.folhar.trabalhadores(payload).then(res => {
        dispatch('ActionSetSevicoGeral',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionFolhaTomador = ({dispatch},payload)=>{
    return serves.folhar.folhatomador(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionFolhaGeral = ({dispatch},payload)=>{
    return serves.folhar.folhageral(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionBaseCalculoDeletar = ({dispatch},payload)=>{
    return serves.folhar.basecalculodelete(payload).then(res => {
        // dispatch('ActionSetMsg',res)
    }).catch(err => {
        // dispatch('ActionSetMsg',err)
    })
}
export const ActionCadastroEvento1270 = ({dispatch},payload)=>{
    return serves.folhar.cadastra1270(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeleteEvento1270 = ({dispatch},payload)=>{
    return serves.folhar.delete1270(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdateEvento1270 = ({dispatch},payload)=>{
    return serves.folhar.update1270(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionBoletim = ({dispatch},payload)=>{
    return serves.folhar.folharboletim(payload).then(res => {
        dispatch('ActionSetBoletim',res)
    }).catch(err => {
        dispatch('ActionSetBoletim',err)
    })
}
export const ActionSetTomadores = ({commit},payload) =>{
    commit(types.SET_TOMADORES,payload)
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetSevico = ({commit},payload) =>{
    commit(types.SET_SERVICO,payload)
}
export const ActionSetSevicoGeral = ({commit},payload) =>{
    commit(types.SET_GERAL,payload)
}
export const ActionSetValorCalculo = ({commit},payload) =>{
    commit(types.SET_VALORCALCULO,payload)
}
export const ActionSetValorCalculoGeral = ({commit},payload) =>{
    commit(types.SET_VALORCALCULO_GERAL,payload)
}
export const ActionSetComissionado = ({commit},payload) =>{
    commit(types.SET_COMISSIONADOR,payload)
}
export const ActionSetDias = ({commit},payload) =>{
    commit(types.SET_DIAS,payload)
}
export const ActionSetBaseCalculo = ({commit},payload) =>{
    commit(types.SET_BASECALCULO,payload)
}
export const ActionSetFolharId = ({commit},payload) =>{
    commit(types.SET_FOLHAR_ID,payload)
}
export const ActionSetQuizena = ({commit},payload) =>{
    commit(types.SET_QUINZENA,payload)
}
export const ActionSetEvento = ({commit},payload) =>{
    commit(types.SET_EVENTO,payload)
}
export const ActionSetBancos = ({commit},payload) =>{
    commit(types.SET_BANCOS,payload)
}
export const ActionSetRublicas = ({commit},payload) =>{
    commit(types.SET_RUBLICAS,payload)
}

export const ActionSetAutomatico= ({commit},payload) =>{
    commit(types.SET_AUTOMATICO,payload)
}

export const ActionSetDiasUteis= ({commit},payload) =>{
    commit(types.SET_DIASUTEIS,payload)
}

export const ActionSetDiasNaoUteis= ({commit},payload) =>{
    commit(types.SET_DIASNAOUTEIS,payload)
}

export const ActionSetFeriado= ({commit},payload) =>{
    commit(types.SET_FERIADO,payload)
}

export const ActionSetFolhas= ({commit},payload) =>{
    commit(types.SET_FOLHAS,payload)
}
export const ActionSetConfigTrabalhador= ({commit},payload) =>{
    commit(types.SET_CONFIGTRABALHADOR,payload)
}
export const ActionSetTrabalhadores= ({commit},payload) =>{
    commit(types.SET_TRABALHADORES,payload)
}
export const ActionSetBoletim= ({commit},payload) =>{
    commit(types.SET_BOLETIM,payload)
}